import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Timeline from "@/components/site/Timeline";
import Services from "@/components/site/Services";
import Differentiators from "@/components/site/Differentiators";
import Mission from "@/components/site/Mission";
import ExecutedProjects from "@/components/site/ExecutedProjects";
import Careers from "@/components/site/Careers";
import Segments from "@/components/site/Segments";
import ServiceArea from "@/components/site/ServiceArea";
import Clients from "@/components/site/Clients";
import Cases from "@/components/site/Cases";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFab from "@/components/site/WhatsAppFab";
import CookieBanner from "@/components/site/CookieBanner";
import AdminPage from "@/pages/AdminPage";
import PrivacyPage from "@/pages/PrivacyPage";
import PortfolioPage from "@/pages/PortfolioPage";

const Site = () => (
  <div className="App min-h-screen bg-[#05121F] text-white font-body">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <About />
      <Timeline />
      <Services />
      <Differentiators />
      <Mission />
      <Clients />
      <ExecutedProjects />
      <Cases />
      <Segments />
      <ServiceArea />
      <Contact />
      <Careers />
    </main>
    <Footer />
    <WhatsAppFab />
    <CookieBanner />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Routes>
          <Route path="/" element={<Site />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
        </Routes>
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: "#0F2A44",
              color: "#fff",
              border: "1px solid #2FA36B",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
